<template>
  <div>
    <div class="row">
      <div class="col-12">
        <router-link :to="{ name:'AdminUsersAdd' }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i> Add User
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Username</th>
            <th>Group</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in filtered_users" :key="user.user_id">
            <td>{{ user.username }}</td>
            <td>{{ user.group.name }}</td>
            <td>
              <div class="dropdown">
                <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <router-link :to="{ name:'AdminUsersEdit', params: { user_id: user.user_id } }"
                               class="dropdown-item"><i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                  </router-link>
                  <a class="dropdown-item" href="#" onclick="return false" @click="deleteUser(user)"><i
                    class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete</a>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'users',
  computed: {
    ...mapGetters({
      users: 'allUsers',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_users: function () {
      return this.users.filter(user => this.showRow(user))
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getUsers')
  },
  methods: {
    showRow (user) {
      // COMM-227
      // Ideally, this stuff should be handled on the server side when the API call is made.
      // The type of user that calls the API dictates the response that is received.
      // Do not display built in user
      if (user.user_id === 1) {
        return false
      }
      
      if (this.logged_in_user.group_id === 3) {
        return true
      } else if (this.logged_in_user.group_id === 2) {
        // if logged in as a site admin you should only see standard/basic/law enforcement users at the scoped site
        if ([1, 6, 7].includes(user.group_id)) {
          if (user.assigned_site_ids[0] === this.scoped_site_id) {
            return true
          }
          // If the user has no assigned site ids, let's just default to site_id = 1
          // We are planning on retiring the multi-site feature anyway.
          if (user.assigned_site_ids.length === 0 && this.scoped_site_id === 1) {
            return true
          }
        }
      } else if (this.logged_in_user.group_id === 4) {
        if (user.group_id !== 3) {
          return true
        }
      }

      return false
    },
    ...mapActions([
      'deleteUser'
    ])
  }
}
</script>

<style scoped>

</style>
